import { FunctionComponent } from 'react';
import {
  ClickAwayListener,
  List,
  ListItem,
  makeStyles,
} from '@material-ui/core';

import { SelectItem } from '@/utils/types';

interface SuggestionListProps {
  loading: boolean;
  text: string;
  options: SelectItem[];
  onSelect: (option?: SelectItem) => void;
  onClickAway: () => void;
}

const useStyles = makeStyles({
  suggestions: (props) => ({
    position: 'absolute',
    top: '44px',
    right: 0,
    left: 0,
    width: '100%',
    maxHeight: '160px',
    padding: '5px 0',
    borderRadius: '8px',
    background: '#0091B3',
    overflowY: 'auto',
    zIndex: 5,
  }),
  suggestion: (props) => ({
    padding: '6.5px 12px',
    color: '#FFFFFF',
    background: '#0091B3',
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '0.5px',
    wordBreak: 'break-all',
    cursor: 'pointer',
    '&:hover': {
      background: '#00748F',
      fontWeight: 600,
    },
    '&.placeholder': {
      cursor: 'default',
      '&:hover': {
        background: 'unset',
        fontWeight: 400,
      },
    },
  }),
});

const BrandSuggestions: FunctionComponent<SuggestionListProps> = ({
  loading,
  text,
  options,
  onSelect,
  onClickAway,
}) => {
  const classes = useStyles();

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <div data-testid="brandSuggestions">
        <List classes={{ root: classes.suggestions }}>
          {options.length > 0 ? (
            options.map((item, index) => (
              <ListItem
                key={index}
                classes={{ root: classes.suggestion }}
                onClick={() => {
                  onSelect(item);
                }}
                data-testid={`brandSuggestion-${index}`}
              >
                {`${item.label} - ${item.value}`}
              </ListItem>
            ))
          ) : text ? (
            <ListItem
              classes={{ root: `${classes.suggestion} placeholder` }}
              onClick={() => {
                onSelect(undefined);
              }}
              data-testid="brandSuggestionPlaceholder"
            >
              {text.trim().length < 2
                ? 'Enter at least 2 characters'
                : 'No options available'}
            </ListItem>
          ) : null}
        </List>
      </div>
    </ClickAwayListener>
  );
};

export default BrandSuggestions;
